import React from "react";

const Iframe = (props: any) => {
    const { url } = props;

    if (!url) { return null; }

    const safeUrl = url.replace(/ /g, "%20");

    return (
        <>
            <div className="small text-muted mb-2">
                Can&rsquo;t see the document below?{" "}
                <a href={safeUrl} target="_blank" rel="noopener noreferrer">
                    Open it in a new tab
                </a>{" "}
                to read it, then come back to this page to continue.
            </div>

            <iframe className={"esign"} src={safeUrl} title="Document preview"></iframe>
        </>
    );
};

export default Iframe;